var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"0","height":"0","border":"0"},attrs:{"src":((this.apiUrl) + "/portal/logout"),"id":"logoutFrame"}})])}
var staticRenderFns = []

export { render, staticRenderFns }